import React from 'react';
import { Link } from 'react-router-dom';
import heroImage from '../assets/hero.jpg';
import './Hero.css';

const Hero = () => {
    return (
        <section className="hero-section">
            <div className="container-fluid p-0">
                <div className="row g-0">
                    {/* Left Side */}
                    <div className="col-lg-6 hero-left">
                        {/* Background Elements */}
                        <div className="hero-bg-leaf"></div>
                        <div className="hero-circle-1"></div>
                        <div className="hero-circle-2"></div>
                        <div className="hero-circle-3"></div>

                        <div className="hero-content">
                            <h1 className="hero-title">Welcome to Zubis Nursery</h1>
                            <p className="hero-description">
                                At Zubis Nursery in Bush Hill Park, Enfield, curiosity leads the way, imagination flourishes, and every child’s potential is lovingly celebrated.
                            </p>
                            <Link to="/contact" className="btn btn-hero">
                                Book Visit
                            </Link>
                        </div>
                    </div>

                    {/* Right Side */}
                    <div className="col-lg-6 hero-right">
                        <img src={heroImage} alt="Happy children at Zubis Nursery" className="hero-image" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
